import React from 'react'
import styled from 'styled-components'

import { PlusCircleIcon } from '@blade/ui-kit'

type Props = {
  label: string
  ref?: React.Ref<HTMLDivElement>
} & React.HTMLAttributes<HTMLDivElement>

export const PlaceholderNode: React.FC<Props> = ({
  label,
  onClick,
  ref,
  ...props
}) => {
  return (
    <Root onClick={onClick} {...props} ref={ref}>
      <PlusCircleIcon size={20} />
      <Label>{label}</Label>
    </Root>
  )
}

const Root = styled.div`
  width: 110px;
  height: 65px;
  display: grid;
  align-items: center;
  align-content: center;
  justify-items: center;
  gap: 2px;
  color: var(--primary-9);

  cursor: pointer;
  border-radius: 6px;
  border: 1px dashed var(--backgroundA-5);
`

const Label = styled.div`
  text-align: center;
  text-transform: capitalize;

  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
`
